import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;
import vuexStorage from '../store/index.js'

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction de création de propale
async function createPropale(idTiers){
    try {
        let response = await requestApi({
            method: 'POST',
            url: '/api/createPropale',
            params: {},
            form: {idTiers: idTiers},
            headers: {'Content-Type': 'application/json'}
        });
        this.$router.push('../editionDevis/' + idTiers + "/" + response.id);
    } catch (error) {
        if(error.response != undefined){
            toasterError(`Impossible de créer le devis`,'Création impossible');
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible');
        }
    }
}

//Fonction de récupération de propale
async function loadPropale(idPropale){
    try {
        let propale = await requestApi({method: 'GET', url: '/api/loadPropale/'+idPropale+'?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
        vuexStorage.commit("setCurrentPropale", propale)
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de charger le devis`,'Chargement impossible')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

//Fonctione changement de rang de ligne
async function changeRang(to, from, reorderTable, ref){
    try {
        await requestApi({method: 'POST', url: '/api/changeLineRang?nocache=' + new Date().getTime(), params: {}, form: {id:from.id, rang:to.rang}, headers: {'Content-Type': 'application/json'}})
        for(const element of reorderTable){
            try {
                if(to.rang > from.rang){
                    await requestApi({method: 'POST', url: '/api/changeLineRang?nocache=' + new Date().getTime(), params: {}, form: {id:element.id, rang:element.rang-1}, headers: {'Content-Type': 'application/json'}})
                  }else{
                    await requestApi({method: 'POST', url: '/api/changeLineRang?nocache=' + new Date().getTime(), params: {}, form: {id:element.id, rang:element.rang+1}, headers: {'Content-Type': 'application/json'}})
                  }
            } catch (error) {
                console.log(error)
                if(error.response != undefined){
                    toasterError(`Impossible de changer l'ordre des lignes`,'Ordre des lignes')
                    if(error.response.status!=404){
                      this.$router.push('/');
                    }
                  }else{
                    toasterError(`Le service est momentanément indisponible`,'Service indisponible')
                  }
            }
        }
        await requestApi({method: 'POST', url: '/api/rebuildDocPropale?nocache=' + new Date().getTime(), params: {}, form: {ref:ref}, headers: {'Content-Type': 'application/json'}})
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de changer l'ordre des lignes`,'Ordre des lignes')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

//Fonction d'ajout de ligne à une propale
async function addLinePropale(id,product,ref){
    try {
        let response = await requestApi({method: 'POST', url: '/api/addLinePropale?nocache=' + new Date().getTime(), params: {}, form: {id:id, product:product}, headers: {'Content-Type': 'application/json'}})
        await requestApi({method: 'POST', url: '/api/rebuildDocPropale?nocache=' + new Date().getTime(), params: {}, form: {ref:ref}, headers: {'Content-Type': 'application/json'}})
        return response
    } catch (error) {
        if(error.response != undefined){
            toasterError(`Impossible d'ajouter la ligne`,'Ajout de ligne')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

//Fonction de suppression de ligne à une propale
async function deleteLinePropale(id,idLine,ref){
    try {
        await requestApi({method: 'POST', url: '/api/deleteLinePropale?nocache=' + new Date().getTime(), params: {}, form: {id:id, idLine:idLine}, headers: {'Content-Type': 'application/json'}})
        await requestApi({method: 'POST', url: '/api/rebuildDocPropale?nocache=' + new Date().getTime(), params: {}, form: {ref:ref}, headers: {'Content-Type': 'application/json'}})
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de supprimer la ligne`,'Suppression de ligne')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

//Fonction de récupération d'infos fournisseur de ligne à une propale
async function getInfosFournisseur(id){
    try {
        let response = await requestApi({method: 'GET', url: '/api/getInfosFournisseur?nocache=' + new Date().getTime(), params: {id:id}, form: {}, headers: {'Content-Type': 'application/json'}})
        return response
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de récupérer les informations du fournisseur`,'Récupération d\'informations')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

//Fonction de modification de ligne de propale
async function modifyLinePropale(idPropale,line,ref){
    try {
        await requestApi({method: 'POST', url: '/api/modifyLinePropale?nocache=' + new Date().getTime(), params: {}, form: {id:idPropale, line:line}, headers: {'Content-Type': 'application/json'}})
        await requestApi({method: 'POST', url: '/api/rebuildDocPropale?nocache=' + new Date().getTime(), params: {}, form: {ref:ref}, headers: {'Content-Type': 'application/json'}})
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de mettre à jour la ligne`,'Modification de ligne')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

//Fonction de récupération des modes de règlements
async function getModeReglement(){
    try {
        let modeReglement = await requestApi({method: 'GET', url: '/api/getModeReglement?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
        let data = []
        modeReglement.forEach(element => {
            data.push({value: element.id, label: element.label, code: element.code})
        })
        this.optionsPayment = data
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de récupérer les modes de règlements`,'Modes de règlement')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

//Fonction de récupération des conditions de règlements
async function getConditionReglement(){
    try {
        let condtionReglement = await requestApi({method: 'GET', url: '/api/getConditionReglement?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
        let data = []
        condtionReglement.forEach(element => {
            data.push({value: element.id, label: element.label, code: element.code, description: element.descr})
        })
        this.optionsConditionsPayment = data
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de récupérer les conditions de règlements`,'Conditions de règlement')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
    toasterError,
    toasterSuccess,
    createPropale,
    loadPropale,
    changeRang,
    addLinePropale,
    getInfosFournisseur,
    deleteLinePropale,
    modifyLinePropale,
    getModeReglement,
    getConditionReglement
}